import React from "react";
import { PatternFormat } from "react-number-format";
import { Field } from "formik";
import {InputContainer} from "styles/components/AnimatedInput";

const PatternFormatInput = (props) => (
  <Field name={props?.name}>
    {({ field, meta }) => (
       <InputContainer>
        <div className="input-container">
          <PatternFormat
            format={props?.format}
            name={field.name}
            // placeholder={props?.placeholder}
            className={`${meta.touched && meta.error ? "error" : ""}`}
            {...field}
          />

          <label className={field.value && 'filled'} htmlFor={props?.name}>
            {props?.placeholder}
          </label>

          {meta.touched && meta.error && (
            <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
          )}
         </div>
      </InputContainer>
    )}
  </Field>
);

export default PatternFormatInput;
